var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"main-container",attrs:{"fluid":""}},[_c('PageHeader',{attrs:{"header":"Registration","subheader":_vm.activeService.name || 'No service selected'}}),_c('Attendees'),_c('MenuItems',{staticClass:"mt-5"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }